<template>
  <div class="HintsTemplate animated fadeIn">
    <label class="HintsTemplate__important">Wybrana opcja:</label>
    {{ isEnabled ? 'Ocena włączona - Zostawienie opinii włączone' : 'Brak oceny' }}
    <ol class="HintsTemplate__description HintsTemplate__list">
      <li>
        Po zakończeniu rozmowy z konsultantem na ekranie systemu call web pojawi się podziękowanie za rozmowę
        (treści można dostosować w zakładce <b>Wygląd i konfiguracja ekranów</b>)
      </li>
      <li v-if="isEnabled">
        Użytkownik będzie miał możliwość oceny rozmowy w skali od 1 do 5.
      </li>
      <li v-if="isEnabled">
        Użytkownik będzie miał również możliwość pozostawienia krótkiej opinii.
      </li>
      <li v-if="isEnabled">
        Oceny i pozostawione opinie pojawią się w zakładce <b>Połączenia</b>.
      </li>
      <li v-if="isEnabled">
        Średnia ocen konsultanta znajduje się w zakładce <b>Numery i konsultanci</b> w sekcji: Konsultanci.
      </li>
    </ol>
  </div>
</template>

<script>
export default {
  name: 'FeedbackAfterConnection',
  props: {
    isEnabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
